/** @jsxRuntime classic */ /** @jsx createElement */ import { createElement } from '@fluentui/react-jsx-runtime';
import { getSlotsNext } from '@fluentui/react-utilities';
import { FixedSizeList as List } from 'react-window';
/**
 * Render the final JSX of DataGridVirtualizedBody
 */ export const renderDataGridBody_unstable = (state)=>{
    const { slots , slotProps  } = getSlotsNext(state);
    return /*#__PURE__*/ createElement(slots.root, slotProps.root, /*#__PURE__*/ createElement(List, {
        itemSize: state.itemSize,
        width: state.width,
        itemData: state.rows,
        height: state.height,
        itemCount: state.rows.length
    }, state.virtualizedRow));
};
